import { ActionWithPayload } from "@obg/ngrx-utils";
import { LiveChatResponse } from "@obg/ngx.common/types";
import { updateState } from "@obg/ngx.global";

import { SUPPORT_ACTION_TYPE } from "./support.action";
import { SupportState } from "./support.model";

const INITIAL_STATE: SupportState = {
	isBusy: false,
	liveChatUrl: "",
};

export function supportReducer(state = INITIAL_STATE, action: ActionWithPayload): SupportState {
	switch (action.type) {
		case SUPPORT_ACTION_TYPE.getLiveChatUrl: {
			return updateState(state, {
				...INITIAL_STATE,
				isBusy: true,
			});
		}
		case SUPPORT_ACTION_TYPE.getLiveChatUrlSuccess: {
			const payload = action.payload as LiveChatResponse;
			return updateState(state, {
				isBusy: false,
				liveChatUrl: payload.url,
			});
		}
		default:
			return state;
	}
}
